import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for an ArrayToRecords task.
 * Expands a nested array in processingData into individual flow records —
 * one record per array element. contextData is inherited from the source record.
 */
export class ArrayToRecordsConfig extends DestinationTaskConfigBase {
	/**
	 * Dot-notation path within processingData to the array to expand.
	 * Throws at runtime if the path is not found or the resolved value is not an array.
	 * @example 'items'  'results.data'
	 * @default ''
	 */
	arrayFieldKey = '';

	constructor(init?: Partial<ArrayToRecordsConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
